/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInputNumberDecimal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 15.023h-1v-1h1zM7.816 9.16c.619 0 1.099.141 1.44.424.341.283.512.685.512 1.208 0 .213-.043.426-.128.64a3.334 3.334 0 0 1-.424.72c-.192.262-.454.576-.784.944l-.808.888h2.16V15H6v-.84l1.456-1.6c.283-.31.502-.56.656-.752a2.67 2.67 0 0 0 .336-.496.927.927 0 0 0 .096-.384c0-.485-.307-.728-.92-.728-.432 0-.922.146-1.472.44V9.568c.25-.128.52-.226.808-.296.293-.074.58-.112.856-.112zm6.44 5.84H13v-4.24l-1.328.448v-.736l1.696-1.208h.888zm3.828 0h-1.256v-4.24l-1.328.448v-.736l1.696-1.208h.888z" />
        <path d="M21.998 19h-20V5h20zm-18-2h16V7h-16z" />
      </g>
    </g>
  </Icon>
);
export { SvgInputNumberDecimal as InputNumberDecimal };
